/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphBulletIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Bullet',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 8.5v3a.5.5 0 0 0 .5.5H8V8H2.5a.5.5 0 0 0-.5.5ZM29.5 8H16v4h13.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5ZM14 16H2.378a.378.378 0 0 0-.378.378v3.244a.378.378 0 0 0 .378.378H14ZM2 24.5v3a.5.5 0 0 0 .5.5H20v-4H2.5a.5.5 0 0 0-.5.5ZM33.5 24H28v4h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5Z"
    />
    <rect height="8" rx="1" ry="1" width="4" x="10" y="6" />
    <rect height="8" rx="1" ry="1" width="4" x="16" y="14" />
    <rect height="8" rx="1" ry="1" width="4" x="22" y="22" />
  </svg>`;
};
